module.exports = __webpack_public_path__ + "img/tiktok.95df0125.png";